module.exports = __webpack_public_path__ + "svg/heart.svg?e5d506058a265d83f63e9ddb865a8e4c";